import { forwardRef, Fragment, memo } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import "./SearchEngineStepLabel.scss";

const SearchEngineStepLabel = forwardRef(
	({ isComplete, className, defaultLabel, label, onClick }, ref) => {
		return (
			<h4
				className={classNames("search-engine-step-label", className)}
				ref={ref}
				onClick={onClick}
			>
				{isComplete ? (
					<Fragment>
						<div className="search-engine-step-label__label">{label}</div>
						<div className="search-engine-step-label__edit">
							<FormattedMessage id="search.engine.edit.label" />
						</div>
					</Fragment>
				) : (
					defaultLabel
				)}
			</h4>
		);
	}
);

SearchEngineStepLabel.propTypes = {
	isComplete: PropTypes.bool,
	defaultLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	className: PropTypes.string,
	onClick: PropTypes.func,
};

SearchEngineStepLabel.defaultProps = {
	onClick: () => {},
};

export default memo(SearchEngineStepLabel);
